import { Board } from "./board";

// Progress persists in localStorage so a puzzle resumes and the picker can mark
// finished ones. Keyed by the stable puzzle code; the "done" set is by number.

const progKey = (code: string): string => `sws:p:${code}`;
const DONE_KEY = "sws:done";

export interface Progress {
  v: Record<number, string>; // entered letters
  p: Record<number, string[]>; // pencil marks
}

export function loadProgress(code: string): Progress | null {
  try {
    const s = localStorage.getItem(progKey(code));
    return s ? (JSON.parse(s) as Progress) : null;
  } catch {
    return null;
  }
}

export function saveProgress(code: string, board: Board): void {
  const v: Record<number, string> = {};
  const p: Record<number, string[]> = {};
  for (let i = 0; i < 81; i++) {
    if (board.given[i]) continue;
    const val = board.value[i];
    if (val) v[i] = val;
    else if (board.pencil[i].size) p[i] = [...board.pencil[i]];
  }
  try {
    localStorage.setItem(progKey(code), JSON.stringify({ v, p }));
  } catch {
    /* storage full / disabled — fine */
  }
}

export function clearProgress(code: string): void {
  try {
    localStorage.removeItem(progKey(code));
  } catch {
    /* ignore */
  }
}

export function applyProgress(board: Board, pr: Progress): void {
  for (const [i, letter] of Object.entries(pr.v || {})) board.set(Number(i), letter);
  for (const [i, letters] of Object.entries(pr.p || {}))
    for (const l of letters) board.togglePencil(Number(i), l);
}

export function doneSet(): Set<number> {
  try {
    const s = localStorage.getItem(DONE_KEY);
    return new Set(s ? (JSON.parse(s) as number[]) : []);
  } catch {
    return new Set();
  }
}

export function markDone(n: number): void {
  try {
    const s = doneSet();
    s.add(n);
    localStorage.setItem(DONE_KEY, JSON.stringify([...s]));
  } catch {
    /* ignore */
  }
}
